import "./RollerDoorRepairSydney.module.css";
import Header from "@/reusable_sections/Header";
import GarageHero from "./sections/GarageHero";
import GaragePillars from "./sections/GaragePillars";
import RollerServices from "./sections/RollerServices";
import Security from "./sections/Security";
import GarageProcess from "./sections/GarageProcess";
import WhyUs from "./sections/WhyUs";
import GarageRepair from "./sections/GarageRepair";
import GarageServices from "./sections/GarageServices";
import Rollerfaq from "./sections/Rollerfaq";
import Garage from "./sections/Garage";
import ServiceAreaExplorer from "./sections/ServiceAreaExplorer";
export default function RollerDoorRepairSydneyPage() {
  return <div>
      <Header />
      <GarageHero />
      <GaragePillars />
      <RollerServices />
      <Security />
      <GarageProcess />
      <WhyUs />
      <GarageRepair />
      <GarageServices />
      <Rollerfaq />
      <Garage />
      <ServiceAreaExplorer />
    </div>;
}